import { render, staticRenderFns } from "./index.vue?vue&type=template&id=46f6806e"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nortonpigozzo/Development/nisoftwares/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46f6806e')) {
      api.createRecord('46f6806e', component.options)
    } else {
      api.reload('46f6806e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=46f6806e", function () {
      api.rerender('46f6806e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/components/logger/index.vue"
export default component.exports